import '../../../assets/style/HPC3.css';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

// import ab1 from "../../../assets/photo/about1.webp";
// import ab2 from "../../../assets/photo/about2.webp";
// import ab3 from "../../../assets/photo/about3.webp";

import ic1 from "../../../assets/icon/icon1.svg";
import ic2 from "../../../assets/icon/icon2.svg";
import ic3 from "../../../assets/icon/icon3.svg";
import { useTranslation } from "react-i18next";

function HPC3() {
    const { t } = useTranslation();
    const listAbout = [{
        src: ic1,
        text: t("hpc3skill1")
    },
    {
        src: ic2,
        text: t("hpc3skill2")
    },
    {
        src: ic3,
        text: t("hpc3skill3")
    }];


    return(
        <section className='HCP3'>
            <div className='leftHCP3'>
                <img src="/photo/about1.webp" className='imageAbout' alt="ab1" loading='eager' fetchPriority='high'></img>
                <div className='leftBottomHCP3'>
                    <div>
                    <   img src="/photo/about2.webp" className='imageAbout' alt="ab2" loading='eager' fetchPriority='high'></img>
                    </div>
                    <div>
                        <img src="/photo/about3.webp" className='imageAbout' alt="ab3" loading='eager' fetchPriority='high'></img>
                    </div>
                </div>
            </div>
            <div className='rightHCP3'>
                <h2>{t("hpc3title")}</h2>
                <p className='textHCP3'>{t("hpc3text")}</p>
                <div className='listAIHCP3 goneMobile'>
                    {listAbout.map((item, index) => (
                        <div key={index} className='AIHCP3'>
                            <img src={item.src} alt="icon"></img>
                            <p>{item.text}</p>
                        </div>
                    ))}
                </div>

                <div className="listAIHCP3Mobile">
                    <Carousel
                        additionalTransfrom={0}
                        arrows={false}
                        autoPlaySpeed={2000}
                        centerMode={false}
                        className=""
                        containerClass="container-with-dots"
                        dotListClass=""
                        draggable
                        focusOnSelect={false}
                        infinite
                        itemClass=""
                        keyBoardControl
                        minimumTouchDrag={80}
                        pauseOnHover
                        renderArrowsWhenDisabled={false}
                        renderButtonGroupOutside={false}
                        renderDotsOutside={false}
                        responsive={{
                            desktop: {
                                breakpoint: {
                                    max: 3000,
                                    min: 1024
                                },
                                items: 8,
                                partialVisibilityGutter: 40
                            },
                            mobile: {
                                breakpoint: {
                                    max: 464,
                                    min: 0
                                },
                                items: 1,
                                partialVisibilityGutter: 30
                            },
                            tablet: {
                            breakpoint: {
                                max: 1024,
                                min: 464
                            },
                            items: 1,
                            partialVisibilityGutter: 30
                            }
                        }}
                        rewind={false}
                        rewindWithAnimation={false}
                        rtl={false}
                        shouldResetAutoplay
                        showDots={false}
                        sliderClass=""
                        slidesToSlide={1}
                        swipeable
                        autoPlay={true}
                    >
                        {listAbout.map((item, index) => (
                            <div key={index} className='AIHCP3'>
                                <img src={item.src} alt="icon"></img>
                                <p>{item.text}</p>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </div>
        </section>
    )
}

export default HPC3;